import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/layouts/Home.vue";
import AuthGuard from "./guards/auth";

Vue.use(VueRouter);

export default new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
      beforeEnter: AuthGuard,
      children: [
        {
          path: "users",
          name: "Users",
          component: () =>
            import(
              /* webpackChunkName: "users" */ "../views/admin/users/UserIndex.vue"
            ),
        },
        {
          path: "users/:id/",
          component: () =>
            import(
              /* webpackChunkName: "userDetail" */ "../views/admin/users/UserShow.vue"
            ),
          children: [
            {
              path: "",
              name: "userDetail",
              component: () =>
                import(
                  /* webpackChunkName: "userNote" */ "../views/admin/users/components/Notes.vue"
                ),
            },
            {
              path: "sessions",
              name: "UserSessions",
              component: () =>
                import(
                  /* webpackChunkName: "userSession" */ "../views/admin/users/components/Sessions.vue"
                ),
            },
            {
              path: "permissions",
              name: "UserPermissions",
              component: () =>
                import(
                  /* webpackChunkName: "userPermission" */ "../views/admin/users/components/Permissions.vue"
                ),
            },
            {
              path: "cards",
              name: "UserCards",
              component: () =>
                import(
                  /* webpackChunkName: "userCards" */ "../views/admin/users/components/Cards.vue"
                ),
            },
            {
              path: "userTrips",
              name: "UserTrips",
              component: () =>
                import(
                  /* webpackChunkName: "userCards" */ "../views/admin/users/components/UserTrips.vue"
                ),
            },
            {
              path: "driver",
              name: "UserDriver",
              component: () =>
                import(
                  /* webpackChunkName: "userDriver" */ "../views/admin/users/components/Driver.vue"
                ),
              children: [
                {
                  path: "vehicles",
                  name: "UserVehicles",
                  component: () =>
                    import(
                      /* webpackChunkName: "userVehicles" */ "../views/admin/users/components/Vehicles.vue"
                    ),
                },
                {
                  path: "company",
                  name: "UserCompany",
                  component: () =>
                    import(
                      /* webpackChunkName: "userCompany" */ "../views/admin/users/components/Company.vue"
                    ),
                },
                {
                  path: "driverMemberships",
                  name: "DriverMemberships",
                  component: () =>
                    import(
                      /* webpackChunkName: "diverActions" */ "../views/admin/users/components/DriverMembership.vue"
                    ),
                },
                {
                  path: "driverMembershipsPayments",
                  name: "DriverMembershipsPayments",
                  component: () =>
                    import(
                      /* webpackChunkName: "diverActions" */ "../views/admin/users/components/DriverMembershipPayments.vue"
                    ),
                },
                {
                  path: "status",
                  name: "DriverStatus",
                  component: () =>
                    import(
                      /* webpackChunkName: "driverStatus" */ "../views/admin/users/components/DriverStatus.vue"
                    ),
                },
                {
                  path: "driverTrips",
                  name: "DriverTrips",
                  component: () =>
                    import(
                      /* webpackChunkName: "driverStatus" */ "../views/admin/users/components/DriverTrips.vue"
                    ),
                },
                {
                  path: "driverEarnings",
                  name: "DriverEarnings",
                  component: () =>
                    import(
                      /* webpackChunkName: "driverEarnings" */ "../views/admin/users/components/reports/DriverEarningComponent.vue"
                    ),
                },
                {
                  path: "driverActions",
                  name: "DriverActions",
                  component: () =>
                    import(
                      /* webpackChunkName: "diverActions" */ "../views/admin/users/components/reports/DriverActionStatusComponent.vue"
                    ),
                },
              ],
            },
          ],
        },
        {
          path: "sessions",
          name: "sessions",
          component: () =>
            import(
              /* webpackChunkName: "sessions" */ "../views/admin/sessions/SessionsIndex.vue"
            ),
        },
        {
          path: "vehicles",
          name: "vehicles",
          component: () =>
            import(
              /* webpackChunkName: "vehicles" */ "../views/admin/vehicles/VehicleIndex.vue"
            ),
        },
        {
          path: "trip/pricing",
          name: "TripPricing",
          component: () =>
            import(
              /* webpackChunkName: "vehicles" */ "../views/admin/trips/PricingIndex.vue"
            ),
        },
        {
          path: "trip/membershipprice",
          name: "MembershipPrice",
          component: () =>
            import(
              "../views/admin/trips/MembershipPrice.vue"
            ),
        },
        {
          path: "trip/protectionprice",
          name: "ProtectionPrice",
          component: () =>
            import(
              "../views/admin/trips/ProtectionPrice.vue"
            ),
        },
        {
          path: "specialdays",
          name: "SpecialDays",
          component: () =>
            import(
              "../views/admin/trips/SpecialDays.vue"
            ),
        },
        {
          path: "trips",
          name: "Trips",
          component: () =>
            import(
              /* webpackChunkName: "trips" */ "../views/admin/trips/TripIndex.vue"
            ),
        },
        {
          path: "trip/:id",
          name: "tripDetail",
          component: () =>
            import(
              /* webpackChunkName: "trips" */ "../views/admin/trips/TripShow.vue"
            ),
        },
        {
          path: "/",
          name: "Dashboard",
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */ "../views/admin/dashboard/DashboardIndex"
            ),
        },
      ],
    },
    {
      path: "/login",
      name: "Login",
      component: () =>
        import(/* webpackChunkName: "login" */ "../views/guest/Login.vue"),
    },
    {
      path: "*",
      name: "NotFound",
      component: () =>
        import(/* webpackChunkName: "404" */ "../views/layouts/404.vue"),
    },
  ],
});
